export default __webpack_public_path__ + "static/media/Star.2f0542a2.svg";